import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { logout } from "../../app/Api";
import { setIsHomeProcess } from "../../app/GlobalSlice";
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { notifyError, notifySuccess } from "../../utils/Notification";
import { isPhone } from "../../utils/PlatformHelper";

const FinishRegistrationPage = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()


  const {
    member,
    screenSize,
    systemProfile
  } = useSelector(state => state.global)

  const [hashImage, setHashImage] = useState(Date.now());

  function onLogout() {
    dispatch(setIsHomeProcess(true))

    logout()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Logout Berhasil')
            navigate("/login")
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => { dispatch(setIsHomeProcess(false)) })
  }

  return (
    <div
      className="h-screen"
      style={{
        backgroundColor: isPhone(screenSize.width) ? 'white' : '#232745'
      }}
    >
      <div
        className="py-10 flex justify-center"
      >
        <div
          className="relative rounded-sm flex"
          style={{
            width: '650px',
            // height: '700px'
          }}
        >

          <div
            className="flex-1 bg-white"
          >
            <div
              className="py-5 pt-8 text-center uppercase font-bold" 
              style={{
                fontFamily: 'Nunito',
                fontSize: '20px'
              }}
            >
              <label>Pendaftaran Selesai</label>
            </div>
            <div
              className="flex justify-center py-5"
            >
              <img src={systemProfile.companyLogo + '?' + hashImage} width={'250px'}/>
            </div>
            <div
              className="py-5 px-10 bg-blue-100 text-center"
              style={{
                fontSize: '14px'
              }}
            >
              <p>Terima Kasih telah menyelesaikan proses pendaftaran.</p>
              <p>Kami akan segera memproses formulir biodata beserta berkas-berkas yang telah anda unggah.</p>
              <p>Mohon tunggu informasi lebih lanjut dari kami.</p>
            </div>
            <div
              className="py-5 flex justify-center border-t"
            >
              <div
                className="w-2/3 px-10 space-y-5"
              >
                <button
                  className="w-full border border-blue-500 py-1.5 rounded-md hover:bg-blue-500 hover:text-white"
                  style={{
                    fontSize: '14px'
                  }}
                  onClick={onLogout}
                >
                  Keluar
                </button>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  )

}

export default FinishRegistrationPage;